import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductType, Ticket } from 'core-lib';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { PaymentLibService } from '../payment-lib.service';
import { PaymentBookingRequest, PaymentIntent, SelectableWalletElement } from '../payment.models';


@Component({
    selector: 'lib-payment-booking',
    templateUrl: './payment-booking.component.html',
    styleUrls: ['./payment-booking.component.scss'],
    standalone: false
})
export class PaymentBookingComponent implements OnInit {
  @Input() intent: PaymentIntent;
  @Output() book = new EventEmitter<any>();
  @Output() goto = new EventEmitter<string>();

  allRequetsFilled = false;
  walletElements: SelectableWalletElement[] = []
  bookingRequests: PaymentBookingRequest[];

  capacityPerWalletElement: { string?: number } = {};

  constructor(private paymentService: PaymentLibService) {

  }

  /**
   * 
   * @param index 
   * @param event 
   */
  onTicketSelected(index: number, event: DropdownChangeEvent) {
    this.updateAvailabelWalletElements();
  }

  /**
   * update available elements
   */
  updateAvailabelWalletElements(): void {
    this.allRequetsFilled = this.bookingRequests.filter(r => r.walletElement == null).length == 0;
    this.capacityPerWalletElement = {};
    for (const we of this.walletElements) {
      switch (we.element.product.type) {
        case ProductType.SingleTicket: {
          this.capacityPerWalletElement[we.element.id] = 1;
          break;
        }
        case ProductType.MultiTicket: {
          this.capacityPerWalletElement[we.element.id] = we.element.usageLimit - we.element.usageCount;
          break;
        }
        case ProductType.SeasonTicket: {
          this.capacityPerWalletElement[we.element.id] = 1;
          break;
        }
        default: {
          this.capacityPerWalletElement[we.element.id] = 0;
          break;
        }
      }
      this.bookingRequests.filter((pr) => pr.walletElement != null).forEach((pr) => {
        this.capacityPerWalletElement[pr.walletElement]--;
      });
      this.walletElements.forEach((we) => {
        setTimeout(() => {
          we.disabled = this.capacityPerWalletElement[we.element.id] <= 0;
        }, 500)
      });
    }
  }

  ngOnInit(): void {
    /**
     * load wallet
     */
    this.paymentService.loadWallet().subscribe((allWalletElements) => {
      const matchingResults = allWalletElements.filter((el: Ticket) => this.intent.productDefinitionIds.indexOf(el.product.id) > -1)
      this.walletElements = matchingResults.map((we) => new SelectableWalletElement(we));
      this.bookingRequests = this.intent.positions.map(pos => {
        return { walletElement: null, id: pos.id }
      });

      /*
      prefill form
      */
      for (const we of this.walletElements){
        const bookingRequest = this.bookingRequests.find((request)=>request.walletElement==null);
        if (bookingRequest == null){
          break;
        }
        bookingRequest.walletElement = we.element.id;
      }
      this.updateAvailabelWalletElements();

      //automatic submit when only one wallet element and one booking request
      //erstemal wieder disabled. Kritik von Valentin
      /*if (this.allRequetsFilled && this.bookingRequests.length == 1){
        this.book.emit(this.bookingRequests);
      }*/
    });
  }
}
